import React, { useState, useEffect } from 'react';
import LoginMobile from './LoginMobile';
import LoginDesktop from './LoginDesktop';

// Main Login Component - Router between Mobile and Desktop
const Login: React.FC = () => {
  // Check if user is on mobile device
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  // Update isMobile state when window is resized
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    // Add event listener
    window.addEventListener('resize', handleResize);
    
    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Choose the appropriate component based on screen size
  return isMobile ? <LoginMobile /> : <LoginDesktop />;
};

export default Login;